var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-text-field',_vm._b({attrs:{"type":"number"},on:{"change":_vm.onCurrencyChange},model:{value:(_vm.processedValue),callback:function ($$v) {_vm.processedValue=$$v},expression:"processedValue"}},'v-text-field',_vm.childProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }